import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { API_BASE_URI } from "../../http/api";
import { Observable } from "rxjs";
import { DetailRequest, DetailRequestBuilder } from "../../http/detail";
import { AdvancedReportOption, NewReportOption } from "@core/data/types/advanced-report";
import { ReportHttpHelperService } from "./advanced-report-http-helper.service";

@Injectable()
export class AdvancedReportOptionService {

    constructor(
        @Inject(API_BASE_URI) private _baseUri: string,
        private _http: HttpClient,
        private _httpHelperService: ReportHttpHelperService,
    ) {}

    get(key: string, shareKey: string = null, detail?: DetailRequest): Observable<AdvancedReportOption> {
        const params = detail ? DetailRequestBuilder.queryParams(detail) : {};
        return this._http.get<AdvancedReportOption>(`${this._baseUri}/advanced-report/option/${key}`, this._httpHelperService.withShareKey({params}, shareKey));
    }

    create(model: NewReportOption): Observable<AdvancedReportOption> {
        return this._http.post<AdvancedReportOption>(`${this._baseUri}/advanced-report/option`, model);
    }

    update(key: string, model: AdvancedReportOption): Observable<AdvancedReportOption> {
        return this._http.put<AdvancedReportOption>(`${this._baseUri}/advanced-report/option/${key}`, model);
    }

    lock(key: string, model: AdvancedReportOption) {
        return this._http.put<AdvancedReportOption>(`${this._baseUri}/advanced-report/option/lock/${key}`, model);
    }
}